import { Center, Loader } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

import RotateDeviceStub from '@/components/shared/RotateDeviceStub';
import { withAuth } from '@/hocs/withAuth';
import { withOrganizations } from '@/hocs/withOrganizations';
import QueryParamsStoreInitializer from '@/stores/global/RootStore/QueryParamsStore/QueryParamsStoreConnector';

import Header from './Header';

import s from './RootLayout.module.scss';

const RootLayout: React.FC = withAuth(
  withOrganizations(() => {
    return (
      <>
        <QueryParamsStoreInitializer>
          <Header />
          <React.Suspense
            fallback={
              <Center>
                <Loader />
              </Center>
            }
          >
            <Outlet />
          </React.Suspense>
          <RotateDeviceStub />
        </QueryParamsStoreInitializer>
        <Notifications position="top-right" classNames={{ root: s.notificationsRoot, notification: s.notification }} />
      </>
    );
  }),
);

export default RootLayout;
